<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "App",
  mounted() {
    try {
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault();
      });
    } catch (e) {
      console.log("🚀 ~ file: Home.vue:87 ~ activated ~ e", e)
    }
  }
};
</script>

<style>
*>>>.van-radio__label {
  white-space: nowrap;
  /* 防止文本自动换行 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
  text-overflow: ellipsis;
  /* 使用省略号表示溢出的文本 */
  max-width: 100%;
  /* 设置最大宽度 */
}


</style>